import { render, staticRenderFns } from "./RejectedSession_UserDetail.vue?vue&type=template&id=45b87122&"
import script from "./RejectedSession_UserDetail.vue?vue&type=script&lang=js&"
export * from "./RejectedSession_UserDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports